import { CREATING, MAIN } from '../../../../constants/shared/states/names';
import { GTMStartElf } from '../../../../constants/analytics/GTM';
import useStateControls from '../../../useStateControls';
import { useUser } from '../../../../redux/reducer/user';
import { useService } from '../../../../redux/reducer/service';
import useServiceData from '../../../useServiceData';
import { useModal } from '../../../useModal';

export const useActions = ({ isModal, setActiveSlide, activeSlide, rulesList }) => {
  const { isFirstEntry } = useUser();
  const { serviceData } = useService();
  const { save } = useServiceData();
  const { id, closeModal } = useModal();

  const { setState } = useStateControls();

  const actions = {
    changeState() {
      setState(isFirstEntry ? CREATING : MAIN);
    },
    nextRule() {
      if (activeSlide < rulesList.length - 1) {
        setActiveSlide((prev) => ++prev);
        return;
      }

      if (isModal) {
        closeModal?.(id);
        return;
      }

      isFirstEntry && GTMStartElf();

      const allEvents = rulesList.reduce((acc, slide) => (!slide?.event ? false : { ...acc, [slide.event]: true }), {});

      if (Object.keys(allEvents).length) save('modalsData', { ...(serviceData?.modalsData ?? {}), ...allEvents });

      actions.changeState();
    },
  };

  return actions;
};
